
import {catchError} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from '../fgi-back-end.service';
import { TaxaJurosEquivalente } from 'src/app/model/taxa-juros-equivalente.model';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
  providedIn: 'root'
})
export class TaxaJurosEquivalenteService extends FgiBackEndService<any>{
  // @Override
  getNewEntity() {
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return undefined;
  }

  public remover(id: number): Observable<unknown> {
    const options: any = blockUi();
    return this.http.post('rest/front/taxa-juros-equivalente/' + id + "/excluir", null, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<unknown>;
  }

  public salvar(taxa: TaxaJurosEquivalente): Observable<TaxaJurosEquivalente> {
    const options: any = blockUi();
    return this.http.post('rest/front/taxa-juros-equivalente', taxa, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<TaxaJurosEquivalente>;
  }

 public buscarTodos(): Observable<TaxaJurosEquivalente[]> {
    const options: any = blockUi();
    return this.http.get(`rest/front/taxa-juros-equivalente`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<TaxaJurosEquivalente[]>;
  }

 
  
}